<template>
	<div id="ProductComponent" class="productComponent">
		<button ref="btnGetProduct" @click="showProductLocal" v-show="false">Buscar Producto</button>
		<button ref="btnClearObjectProduct" @click="clearObjectProduct" v-show="false">Limpiar Objeto Producto</button>
		<div v-if="searchingProduct" class="text-center">
			Buscando Producto
		</div>
		
		<div v-else class="product">
			<i class="fas fa-redo text-muted pointer" style="float: right; position: absolute; right: 20px; z-index: 1;" @click="showProductLocal"></i>
			<div class="row">
				<div class="col-md-4 img">
					<img :src="(objectProduct.img == null || objectProduct.img == '') ? '/img/img-not-found.png' : objectProduct.img">
					<div>
						<input type="text" class="form-control form-control-sm" id="inputId" placeholder="URL de la imagen" v-model="objectProduct.img" :disabled="!btnSaveVisibility">
					</div>
				</div>
				<div class="col-md-8 data">
					<div>
						<div class="form-row">
							<div class="form-group col-md-2">
								<label for="inputId">Código</label>
								<div class="input-group input-group-sm">
									<input type="number" class="form-control" id="inputId" placeholder="Código" v-model="objectProduct.id" :disabled="(objectProduct.exists == 1 || !btnSaveVisibility)">
									<div class="input-group-prepend" v-if="(objectProduct.exists == 1 && objectProduct.id > 0)">
										<div class="input-group-text pointer" id="btnGroupAddon" title:="Imprimit etiqueta">
											<i class="fas fa-ticket-alt" data-toggle="modal" data-target="#printerLabelModal" ></i>
										</div>
									</div>
								</div>
							</div>
							<div class="form-group col-md-7">
								<label for="inputName">Titulo</label>
								<input type="text" class="form-control form-control-sm" id="inputName" ref="inputName" placeholder="Titulo" v-model="objectProduct.name" :disabled="!btnSaveVisibility">
							</div>
							<div class="form-group col-md-3">
								<label for="inputSynthetic">Sintetico</label>
								<input type="text" class="form-control form-control-sm" id="inputSynthetic" placeholder="Sintetico" v-model="objectProduct.synthetic" :disabled="!btnSaveVisibility">
							</div>
						</div>
						<div class="form-row">
							<div class="form-group col-md-4">
								<label for="inputISBN">ISBN</label>
								<input type="text" class="form-control form-control-sm" id="inputISBN" placeholder="ISBN" v-model="objectProduct.isbn" :disabled="!btnSaveVisibility">
							</div>
							<div class="form-group col-md-2">
								<label for="inputLength">Largo</label>
								<input type="number" class="form-control form-control-sm" id="inputLength" placeholder="Largo" v-model="objectProduct.length" :disabled="!btnSaveVisibility">
							</div>
							<div class="form-group col-md-2">
								<label for="inputWidth">Ancho</label>
								<input type="number" class="form-control form-control-sm" id="inputWidth" placeholder="Ancho" v-model="objectProduct.width" :disabled="!btnSaveVisibility">
							</div>
							<div class="form-group col-md-2">
								<label for="inputHeight">Alto (grosor)</label>
								<input type="number" class="form-control form-control-sm" id="inputHeight" placeholder="Alto (grosor)" v-model="objectProduct.height" :disabled="!btnSaveVisibility">
							</div>
							<div class="form-group col-md-2">
								<label for="inputWeight">Peso</label>
								<input type="number" class="form-control form-control-sm" id="inputWeight" placeholder="Peso" v-model="objectProduct.weight" :disabled="!btnSaveVisibility">
							</div>
						</div>
						<div class="form-row">
							<div class="form-group col-md-2">
								<label for="inputGroup">Grupo</label>
								<select id="inputGroup" class="form-control form-control-sm" v-model="objectProduct.group" :disabled="!btnSaveVisibility">
									<option value="U">Unico</option>
									<option value="G">Grupo</option>
									<option value="P">Suscripción</option>
								</select>
							</div>
							<div class="form-group col-md-3">
								<label for="inputTypeProduct">Tipo de Producto</label>
								<select id="inputTypeProduct" class="form-control form-control-sm" v-model="objectProduct.type_product_id" :disabled="!btnSaveVisibility">
									<option v-for="(i, index) in listTypesProduct" :key="index" :value="i.id">{{ i.name }}</option>
								</select>
							</div>
							<div class="form-group col-md-2">
								<label for="inputTypeBinding">Encuadernación</label>
								<select id="inputTypeBinding" class="form-control form-control-sm" v-model="objectProduct.type_binding_id" :disabled="!btnSaveVisibility">
									<option v-for="(i, index) in listTypesBinding" :key="index" :value="i.id">{{ i.name }}</option>
								</select>
							</div>
							<div class="form-group col-md-2">
								<label for="inputStatus">Estado</label>
								<select id="inputStatus" class="form-control form-control-sm" v-model="objectProduct.status_id" :disabled="!btnSaveVisibility">
									<option v-for="(i, index) in listStatus" :key="index" :value="i.id">{{ i.name }}</option>
								</select>
							</div>
							<div class="form-group col-md-3">
								<label for="inputEditorial">Editorial</label>
								<select id="inputEditorial" class="form-control form-control-sm" v-model="objectProduct.editorial_id" :disabled="!btnSaveVisibility">
									<option v-for="(i, index) in listEditorials" :key="index" :value="i.id">{{ i.name }}</option>
								</select>
							</div>
						</div>
						<div class="text-right">
							<button type="button" class="btn btn-primary btn-sm" @click="saveProductLocal" :disabled="btnSaveProductLocalDisable" v-show="btnSaveVisibility">Guardar</button>
						</div>
						<hr>
					</div>
					<div>
						<ul class="nav nav-tabs" id="myTab" role="tablist">
							<li class="nav-item" role="presentation">
								<button class="nav-link active" id="location-tab" data-toggle="tab" data-target="#location" type="button" role="tab" aria-controls="location" aria-selected="true">
									<i class="fas fa-map-marker-alt"></i> Ubicación
								</button>
							</li>
							<li class="nav-item" role="presentation" v-show="false">
								<button class="nav-link" id="profile-tab" data-toggle="tab" data-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">Profile</button>
							</li>
							<li class="nav-item" role="presentation" v-show="false">
								<button class="nav-link" id="contact-tab" data-toggle="tab" data-target="#contact" type="button" role="tab" aria-controls="contact" aria-selected="false">Contact</button>
							</li>
						</ul>
						<div class="tab-content" id="myTabContent">
							<div class="tab-pane fade show active container" id="location" role="tabpanel" aria-labelledby="location-tab">
								<div class="row mt-1 py-2" v-for="(item, index) in objectProduct.store_rack_side_row_columns" :key="index" :style="'border: 1px solid ' + item.store_rack_side.color">
									<div class="col-md-2 col-6 text-center">{{ item.store.name }}</div>
									<div class="col-md-2 col-6 text-center">{{ item.store_rack.name }}</div>
									<div class="col-md-2 col-4 text-center align-middle align-baseline pointer text-white" :style="'background-color: ' + item.store_rack_side.color" @click="selectSideRowColumn(item.id)">{{ item.store_rack_side.name }}</div>
									<div class="col-md-1 col-4 text-center pointer text-white" :style="'background-color: ' + item.store_rack_side.color" @click="selectSideRowColumn(item.id)">{{ item.store_rack_side_row.name }}</div>
									<div class="col-md-1 col-4 text-center pointer text-white" :style="'background-color: ' + item.store_rack_side.color" @click="selectSideRowColumn(item.id)">{{ item.name }}</div>
									<div class="col-md-2 col-12 text-center">{{ item.pivot.quantity }}</div>
									<div class="col-md-2 col-12 text-center">{{ item.status.name }}</div>
								</div>
							</div>
							<div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">...</div>
							<div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">...</div>
						</div>
					</div>
				</div>
			</div>

			<div class="modal" tabindex="-1" role="dialog" id="printerLabelModal">
				<div class="modal-dialog modal-sm" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title">Impresión de Etiqueta</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<div class="form-group">
								<select class="form-control form-control-sm" v-model="selectedLabelId">
									<option value="7">Articulo</option>
									<option value="6">Caja</option>
								</select>
							</div>
							<div class="form-group" v-if="selectedLabelId == 6">
								<label for="quantityProduct">Cantidad por caja</label>
								<input type="number" class="form-control form-control-sm" id="quantityProduct" v-model="quantityProduct"/>
							</div>
							<div class="form-group">
								<label for="quantityLabel">Nº de impresiones</label>
								<input type="number" class="form-control form-control-sm text-right" id="quantityLabel" v-model="quantityLabel"/>
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-primary btn-sm" @click="printerLabelLocal" :disabled="btnPrinterLabelDisable">Imprimir</button>
							<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" ref="btnArticuloGenesysModal">Cerrar</button>
						</div>
					</div>
				</div>
			</div>

			<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#storeRackSideModal" ref="storeRackSideModal" v-show="false">
				Show Modal StoreRackSideModal
			</button>
			<div class="modal" tabindex="-1" role="dialog" id="storeRackSideModal">
				<div class="modal-dialog modal-lg" role="document">
					<div class="modal-content p-3">
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
						<side-component
							ref="sideComponent"
							:storeRackSideRowColumnIds="storeRackSideRowColumnIds"
							@actionShowStoreRackSideRowColumn = "actionShowStoreRackSideRowColumnLocal">
						</side-component>
					</div>
				</div>
			</div>


		<!-- Button Column Component modal -->
		<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#columnComponentModal" ref="columnComponentModal" v-show="false">
			Abrir Column Component Modal
		</button>

		<!-- Modal Column Component -->
		<div class="modal fade" id="columnComponentModal" tabindex="-1" aria-labelledby="columnComponentModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-xl">
				<div class="modal-content">
					<div class="modal-body">
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
						<column-component
							ref="columnComponent"
							:id="storeRackSideRowColumnIdSelected">
						</column-component>
					</div>
				</div>
			</div>
		</div>


		</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import errors from '@/mixins/errors.js'
	import axiosAction from '@/mixins/axiosAction.js'
	import products from '@/mixins/products'
	import typeProduct from '@/mixins/products/typeProduct.js'
	import typeBinding from '@/mixins/products/typeBinding.js'
	import status from '@/mixins/status'
	import editorial from '@/mixins/generals/editorial.js'
	import label from "@/mixins/labels/"
	import webSocketServer from '@/mixins/webSocketServer.js'

	import SideComponent from '@/components/SideComponent.vue'
	import ColumnComponent from '@/components/ColumnComponent.vue'

	export default {
		name: 'ProductComponent',
		mixins: [axiosAction, errors, mixin, products, typeProduct, typeBinding, status, editorial, label, webSocketServer, ],
		props: ['id', 'autoSearch', 'btnSave'],
		data () {
			return {
				quantityProduct: 0,
				quantityLabel: 1,
				storeRackSideRowColumnIds: [],
				storeRackSideRowColumnIdSelected: 0
			}
		},
		components: {
			'side-component': SideComponent,
			'column-component': ColumnComponent,
		},
		computed: {
			btnSaveProductLocalDisable() {
				if(this.objectProduct.name.trim().length < 5)
					return true
				return false
			},
			btnPrinterLabelDisable() {
				if(this.selectedLabelId < 1)
					return true
				if(isNaN(this.quantityLabel))
					return true
				if(this.quantityLabel < 1)
					return true
				if(this.selectedLabelId == 6) {
					if(isNaN(this.quantityProduct))
						return true
					if(this.quantityProduct < 1)
						return true					
				}
				return false
			},
			getAutoSearch() { // Determina si tiene que limpiar search al hacer enter (default = true)
				if(typeof this.autoSearch == "boolean")
					return this.autoSearch
				return true
			},
			btnSaveVisibility() {
				if(this.btnSave == true) {
					return this.btnSave
				}
				return false
			}
		},
		methods: {
			actionShowStoreRackSideRowColumnLocal(id) {
				this.storeRackSideRowColumnIdSelected = id
				this.$refs.columnComponentModal.click()
				setTimeout(() => {this.$refs.columnComponent.$refs.btnShowStoreRackSideRowColumn.click()}, 100)
			},
			initComponent() {
				this.setInitComponent()
				this.getAllTypesProductLocal()
			},
			getAllTypesProductLocal() {
				this.getAllTypesProduct()
			},
			getAllTypesProductResultLocal(response) {
				if(response.data.success == true) {
					this.getAllTypesBindingLocal()
				}
			},
			getAllTypesBindingLocal(){
				this.getAllTypesBinding()
			},
			getAllTypesBindingResultLocal(response) {
				if(response.data.success == true) {
					this.getAllStatusLocal()
				}
			},
			getAllStatusLocal() {
				this.typeStatusId = 1
				this.getAllStatus()
			},
			getAllStatusResultLocal(response) {
				if(response.data.success == true) {
					this.getAllEditorialsLocal()
				}
			},
			getAllEditorialsLocal() {
				this.getAllEditorials()
			},
			getAllEditorialsResultLocal(response) {},
			printerLabelLocal() {
				this.showLabelLocal()
			},
			resultAxiosLocal(responseLocal, response) {
				switch(responseLocal) {
					case 'getAllEditorialsResult': this.getAllEditorialsResult(response); break;
					case 'getAllTypesBindingResult': this.getAllTypesBindingResult(response); break;
					case 'getAllTypesProductResult': this.getAllTypesProductResult(response); break;
					case 'getAllStatusResult': this.getAllStatusResult(response); break;
					case 'resultShowLabelGET': this.resultShowLabelGET(response); break;
					case 'saveProductResult': this.saveProductResult(response); break;
					case 'showProductResult': this.showProductResult(response); break;
					default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
				}
				this.$emit('hideLockScreen')
			},
			selectSideRowColumn(storeRackSideRowColumnId) {
				this.storeRackSideRowColumnIds = [storeRackSideRowColumnId]
				this.$refs.storeRackSideModal.click()
				setTimeout(() => { this.$refs.sideComponent.$refs.btnGetStoreRackSideRowColumn.click() }, 10)
			},
			setInitComponent() {
				this.selectedLabelId = 0
			},
			saveProductLocal() {
				this.saveProduct()
			},
			saveProductResultLocal(response) {
				if(response.data.success) {
					let title = (response.data.message == 'NUEVO') ? 'Creado' : 'Actualizado'
					if(response.data.message == 'NUEVO') {
						this.$snotify.success('Se ha guardado con exito el articulo', title + '!!!')
					} else {
						this.$snotify.info('Se ha guardado con exito el articulo', title + '!!!')
					}
					this.$emit('actionSaveProduct', response.data.data)
				}
			},
			showLabelLocal() {
				this.showLabel(this.selectedLabelId)
			},
			showLabelResultLocal(response) {
				if(response.data.success == true) {
					let arrayZPL = []
					let quantityLabel = 1
					if(this.selectedLabelId == 6) {
						let name = this.objectProduct.name.substr(0, 40)
						let name_ = this.objectProduct.name.substr(40, 40)
						arrayZPL.push({'name': 'product_id' , 'value': this.objectProduct.id})
						arrayZPL.push({'name': 'isbn' , 'value': (this.objectProduct.isbn == null) ? '' : 'ISBN: ' + this.objectProduct.isbn})
						arrayZPL.push({'name': 'name' , 'value': name.toUpperCase()})
						arrayZPL.push({'name': 'name_' , 'value': name_.toUpperCase()})
						arrayZPL.push({'name': 'codbareti' , 'value': 'H' + this.objectProduct.id})
						arrayZPL.push({'name': 'quantity' , 'value': this.quantityProduct})
						quantityLabel = this.quantityLabel
					} else if (this.selectedLabelId == 7) {
						let length = 30
						let name = (this.objectProduct.name.length > length) ? this.objectProduct.name.substr(0, length - 3) + '...' : this.objectProduct.name
						arrayZPL.push({'name': 'id' , 'value': 'H' + this.fill(this.objectProduct.id, 10)})
						arrayZPL.push({'name': 'name' , 'value': name.toUpperCase()})
						quantityLabel = this.quantityLabel / 2
					}
					this.replaceZPLVariableFromArray(arrayZPL)
					for(let i = 0; i < quantityLabel; i++) {
						this.toPrintWithVariables()
					}
				}
			},
			showProductLocal() {
				this.clearObjectProduct()
				if(this.id != null && this.id != 0 && this.id != '') {
					if(this.getAutoSearch) {
						this.showProduct(this.id)
					} else {
						this.objectProduct.id = this.id
						setTimeout(() => { this.$refs.inputName.focus() }, 200)
					}
				}
			},
			showProductResultLocal(response) {
				if(response.data.success == false) {
					this.$emit('actionProductNotFound', this.id)
				} else {
					this.$emit('actionProductFound', this.objectProduct)
				}
			}
		},
		mounted () {
			this.initComponent()
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
	.productComponent {
		.product {
			.fa-redo {
				opacity: .1;
			}
			input {
				background: transparent;
				color: #6C757D;
			}
			select {
				background: transparent;
			}
			.img {
				img {
					width: 100%;
				}
			}
			.data {
				.name {
					font-size: 28px;
					input {
						width: 100%;
					}
				}
				.codes {
					.isbn {
						input {
							width: 100%;
						}
					}
				}
			}
		}
		.product:hover {
			.fa-redo {
				opacity: .8;
			}
		}
	}
</style>
